class Validators {
  isNumber(field) {
    return !isNaN(Number.parseInt(field))

  }

  validString(field) {
    return field ? true : false
  }

  validEmail(field) {
    return field.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? true : false
  }
}

export default new Validators()



// WEBPACK FOOTER //
// ./src/utils/validators.js